module.exports = __webpack_public_path__ + "static/5-542aea9c7ee3172b2d58601c75fa799d.jpeg";